<template>
  <div class="prices">
    <div class="itens-list">
      <table class="cms-price-table">
        <tbody>
        <tr>
          <th class="prices_table_receive" data-t="Get">
            {{ t("Get") }}
          </th>
          <th :colspan="receiverCurrenciesCount" class="prices_table_payment_options" data-t="Pay now">
            {{ t("Pay now") }}
          </th>
        </tr>
        <tr>
          <th> {{ defaultTopupOption.ReceivableCurrencyCode }}</th>
          <th v-for="item in defaultTopupOption.Pricing">{{ item.PaidCurrencyCode }}</th>
        </tr>
        <tr v-for="item in availableTopupOptions">
          <td>{{ item.ReceivableAmount }}</td>
          <td v-for="price in item.Pricing">{{ price.PaidAmount }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import {TopupAmountItem} from './../../Models/TopupAmountsViewModel';

export default {
  name: "topup-prices",
  data: function () {
    return {
      defaultTopupOption: TopupAmountItem,
      receiverCurrenciesCount: 1
    }
  },
  props: {
    availableTopupOptions: {} as Array<TopupAmountItem>
  },
  beforeMount() {
    this.defaultTopupOption = new TopupAmountItem();
  },
  watch: {
    availableTopupOptions: function (newVal: Array<TopupAmountItem>, _: Array<TopupAmountItem>) {

      if (newVal.length > 0) {
        this.defaultTopupOption = newVal[0];

        if (this.defaultTopupOption.Pricing)
          this.receiverCurrenciesCount = this.defaultTopupOption.Pricing.length;
      }
    }
  },
}
</script>